/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { LogLevelCssClasses } from "../../../../../../../_helpers/Helpers";

export const LevelColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      LogLevelCssClasses[row.level]
    } label-inline`}
  >
    {row.level}
  </span>
);